import React, { PropTypes } from 'react';

import styled from 'styled-components';

import { NitroIcon } from 'nitro-components';

const NavMenu = styled.ul`
  padding: 8px 0 16px;
  margin: 0;
  list-style: none;
`;

const StyledLink = styled.span`
  text-decoration: none;
  color: ${props => props.theme.color.secondary};
`;

const StyledTitle = styled.li`
  display: block;
  padding: 7px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.color.border};
  }
`;

const createMenu = ({ items, menus = [] }) => {
  for (const item of items) {
    const { title, icon } = item;
    const to = item.route || item.url;
    const { route } = item;
    const { url } = item;
    menus.push({ to, title, icon, route, url });

    if (item.children && item.children.length > 0) {
      menus = [...menus, ...createMenu({ items: item.children })];
    }
  }
  return menus;
};

const ProfileMenu = ({ menus, onMenuLinkClick }) => {
  if (menus.length === 0) {
    return null;
  }

  const list = createMenu({ items: menus }).map(menu => (
    <StyledTitle key={menu.to} onClick={() => onMenuLinkClick(menu)}>
      {menu.icon ? (
        <NitroIcon name={menu.icon} size={12} right={14} variant="secondary" />
      ) : null}
      <StyledLink to={menu.to}>{menu.title}</StyledLink>
    </StyledTitle>
  ));

  return <NavMenu>{list}</NavMenu>;
};

ProfileMenu.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.shape({})),
  onMenuLinkClick: PropTypes.func
};

ProfileMenu.defaultProps = {
  menus: [],
  onMenuLinkClick: () => {}
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/components/common/Profile/ProfileMenu.js